import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Global } from '../app.global';
import { CountryList, UserDetails, UserInput } from '../models/data-cleanup-model';
import { ConfirmationDialogService } from '../services/confirmation-dialog.service';
import { DataCleanUpService } from '../services/datacleanup.service';
import { MasterDataService } from '../services/masterdata.service';
import { SessionStorageService } from '../../app/core/services/session-storage.service';
import { UserRolesService } from '../services/user-roles.service';

@Component({
    selector: 'app-dataclean-up',
    templateUrl: './dataclean-up.component.html',
    styleUrls: ['./dataclean-up.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DatacleanUpComponent implements OnInit {
  validateUser: boolean;
  validateUpdateButton: boolean;
  isDisabledMobileNo: boolean = true;
  showUserDetails: boolean = false;
  allowRowCheckboxInGrid: boolean = false;
  iseventRegistered: boolean = false;
  invalidEmailFormat: boolean = false;
  disableReset: boolean = false;
  maskDisable: boolean = false; // Disable mask option by default
  isSearchDisable: boolean = true;
  isMaskDisable: boolean = false; // Disable mask option by default
  selectedRoleId: number = 1; // Assuming 1 is the default role ID for the current user
  allowPagination: boolean = this.selectedRoleId === 1  ? false : true;
  isClientSidePagination: boolean = this.selectedRoleId === 1  ? false : true;
  showLoader: boolean = false;
  userDetailsArray = [];
  totalRecordUserGrid: number = 0;
  userGridColumns: any = [];
  userGridData: any = [];
  searchGridHeight: any;
  countries: Array<CountryList>;
  userInput: UserInput;
  userEmail: any = [];
  userDet: UserDetails;
  successMessageText: string = "";
  emailIdUserName: string;
  userDetails: any;
  userId: string;
  countryCode: string;
  selectedCountryCodeId: number;
  countryCodeId: string;
  mobileNumber: string;
  firstName: string;
  lastName: string;
  countryName: string;
  functionName: string;
  industry: string;
  position: string;
  updateBtnText: string;
  radioBtnName: string;
  radioUpdateNo: boolean;
  radioMask: boolean;
  radioReset: boolean;
  myData: any;
  currentRole: number;
  
  
  constructor(private userRoleService: UserRolesService, private SessionStorageService: SessionStorageService,private datacleanupservice: DataCleanUpService, private masterDataService: MasterDataService,
    private confirmationDialogService: ConfirmationDialogService,
    public global: Global) {

  }

  ngOnInit() {
    this.userRoleService.getUserRoleID().subscribe((res) => {
      this.currentRole = res;
      this.radioReset = false; 
    })
    
    //this.updateBtnText = "Update Mobile Number";

    //if (this.masterDataService.masterData !== undefined) {
    //  this.countries = [];
    //  if (this.masterDataService.masterData && this.masterDataService.masterData.Countries && this.masterDataService.masterData.Countries.length > 0) {
    //    this.masterDataService.masterData.Countries.map(country => {
    //      this.countries.push({
    //        id: country.ID, name: country.Name,
    //        countryCode: country.CountryCode, countryCodeId: country.ID
    //      })
    //    });
    //  }
    //}
    //else {
    //  this.masterDataService.getMasterDataDetails().subscribe((res) => {
    //    this.countries = [];
    //    if (this.masterDataService.masterData && this.masterDataService.masterData.Countries && this.masterDataService.masterData.Countries.length > 0) {
    //      this.masterDataService.masterData.Countries.map(country => {
    //        this.countries.push({
    //          id: country.ID, name: country.Name,
    //          countryCode: country.CountryCode, countryCodeId: country.ID
    //        })
    //      });
    //    }
    //  })
    //}
    this.autoPopulateOnTabChange();
    this.getUserRole();
  }

  public createUserGrid(data) {
        this.userGridColumns = [
          {
            name: "EmailAddress",
            header: "Email",
            dataType: "string",
            minWidth: "130px",
          }, 
          {
            name: "FirstName",
            header: "First Name",
            dataType: "string",
            minWidth: "130px",
          }, 
          {
            name: "LastName",
            header: "Last Name",
            dataType: "string",
            minWidth: "130px",
          }, 
          {
            name: "CountryName",
            header: "Country/Location",
            dataType: "string",
            minWidth: "130px",
          }, 
          {
            name: "SFName",
            header: "Function",
            dataType: "string",
            minWidth: "130px",
          }, 
          {
            name: "Name",
            header: "Industry",
            dataType: "string",
            minWidth: "130px",
          }, 
          {
            name: "JLName",
            header: "Position",
            dataType: "string",
            minWidth: "130px",
          }, 
          {
            name: "Status",
            header: "Status",
            dataType: "string",
            minWidth: "130px",
          }
        ];
        this.showLoader = false;
        this.userGridData = data;
        this.searchGridHeight = (data.length > 10) ? "400px" : "auto";
        this.showUserDetails = true;
        this.allowRowCheckboxInGrid = false;
        this.iseventRegistered = false;
        this.isClientSidePagination = true;
        this.allowPagination = false;
        this.selectedRoleId = 1; // Assuming 1 is the default role ID for the current user
        this.userEmail = [];
        this.userGridData.forEach((item) => {
          if(item.Status === 'Registered'){
            this.userEmail.push({
              emailAddress: item.EmailAddress
            });
          }
        });

        const hasRegistered = this.userGridData.some(item => item.Status === 'Registered');
        const hasNotRegistered = this.userGridData.some(item => item.Status === 'Not Registered');
        const hasNotApplicable = this.userGridData.some(item => item.Status === 'Not Applicable');

         if (this.userGridData.length === 1) {
          this.maskDisable = this.userGridData[0].Status === 'Registered';
          } else {
          if (hasRegistered) {
            this.maskDisable = true;
          } else {
            this.maskDisable = false;
          }
        }

        if(this.emailIdUserName !== '' && this.emailIdUserName !== undefined && this.emailIdUserName !== null) {
          const emails = this.emailIdUserName?.split(';').map(email => email.trim());
          if(emails.length > 1) {
            this.disableReset = true;
          }
        }
        this.totalRecordUserGrid = data.length;
    }
  validateEmails() {
    this.invalidEmailFormat = false;
    if (this.emailIdUserName != "" && this.emailIdUserName != null) {
      // Split the input by semicolon
      const emails = this.emailIdUserName?.split(';').map(email => email.trim());

      // Regular expression for validating email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      for (const email of emails) {
        if (!emailRegex.test(email)) {
          this.invalidEmailFormat = true;  // Invalid email format
          this.isSearchDisable = true;
          return;
        }
      }
      this.isSearchDisable = !this.invalidEmailFormat && (this.radioMask || this.radioReset) ? false : true;

      if (emails.length > 1) {
        this.disableReset = emails.length > 1;
        if (this.radioReset === true) {
          this.radioMask = false;
          this.radioReset = false;
        }
        return;
      } else {
        this.disableReset = false;
      }
    } else {
      this.isSearchDisable = true;
      this.radioMask = false;
      this.radioReset = false;
      this.radioBtnName = null;
    }
  }
  //validateEmails() {
  //  if(this.emailIdUserName !== undefined && this.emailIdUserName !== null && this.emailIdUserName !== "") {
  //    this.invalidEmailFormat = false;
  //  }
  //  if (this.radioMask === true && this.emailIdUserName !== "") {
  //    this.isSearchDisable = false;
  //    this.invalidEmailFormat = false;
  //  }
  //  if (this.emailIdUserName && this.emailIdUserName.trim() !== "") {
  //    if (this.emailIdUserName.includes(',')) {
  //      this.invalidEmailFormat = true;
  //      this.isSearchDisable = true;
  //      return;
  //    }

       

  //    const emails = this.emailIdUserName.split(';').map(email => email.trim()).filter(e => e !== '');
  //    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //    if (emails.length > 1) {
  //      this.disableReset = emails.length > 1;
  //      if(this.radioReset === true) {
  //        this.radioMask = false;
  //        this.radioReset = false;
  //      }
  //      return;
  //    }else{
  //      this.disableReset = false;
  //    }
  //    for (const email of emails) {
  //      if (!emailRegex.test(email)) {
  //        this.invalidEmailFormat = true;
  //        this.isSearchDisable = true;
  //        break;
  //      }
  //    }
  //  }
  //}

  public onSubmitBtnClick() {
    this.showLoader = true;
    this.selectedCountryCodeId = 23;
    this.successMessageText = "";
    this.userInput = {
      userNameOrEmail: Array.from(new Set(this.emailIdUserName.split(';').map(email => email.trim().toLowerCase()).filter(email => email))).join(';')
    };
    this.userDetails = this.datacleanupservice.getUserDetails(this.userInput).subscribe((result) => {
      result = result.Data;
      this.userDetails = result;
      this.userDetailsArray = [];
      this.userDetailsArray = result;
      this.createUserGrid(this.userDetailsArray);

      if (this.userDetails) {
        if (this.userDetails === "N") {
          this.validateUser = true;
          this.userId = "";
          this.firstName = "";
          this.lastName = "";
          this.countryName = "";
          this.functionName = "";
          this.industry = "";
          this.position = "";
        }
        else {
          this.validateUser = false;
          this.userId = this.userDetails.UserId;
          this.firstName = this.userDetails.FirstName;
          this.lastName = this.userDetails.LastName;
          this.countryName = this.userDetails.CountryName;
          this.functionName = this.userDetails.SFName;
          this.industry = this.userDetails.Name;
          this.position = this.userDetails.JLName;
        }
      }
      else {
        this.validateUser = true;
        this.userId = "";
        this.firstName = "";
        this.lastName = "";
        this.countryName = "";
        this.functionName = "";
        this.industry = "";
        this.position = "";
      }
    }
    );
    this.setValuesToMasterDataObj();
  }

  public onUpdateMaskReset() {
    this.successMessageText = "";
    //if (this.updateBtnText === "Update Mobile Number") {
    //  this.userDet = {
    //    emailAddress: this.userInput.userNameOrEmail,
    //    userId: this.userId,
    //    countryCode: this.countryCode,
    //    mobileNumber: this.mobileNumber,
    //    countryCodeID: this.selectedCountryCodeId.toString()
    //  };
    //  this.datacleanupservice.updateMobileNo(this.userDet).subscribe((result) => {
    //    this.successMessageText = "Profile Updated";
    //  });
    //}
    /*else {*/
      this.userDet = {
        emailAddress: this.userEmail.map(email => email.emailAddress).join(';')
      };
      let userinput: number = 3;
      if (this.updateBtnText === "Mask User") {
        userinput = 2;
      }
      if (userinput === 2) {
        this.openConfirmationDialog(userinput);
      }
      else {
        this.datacleanupservice.updateMaskNResetAssessment(this.userDet, userinput).subscribe((result) => {
          this.successMessageText = ("Reset Assessment completed.");
          // this.showUserDetails = false;
        });
      }
   // }
    this.setValuesToMasterDataObj();
  }

  public onRadioBtnClick(radioBtnName: string) {
    this.radioBtnName = radioBtnName;
    //if (radioBtnName === "updateMobile") {
    //  this.updateBtnText = "Update Mobile Number";
    //  this.isDisabledMobileNo = false;
    //  this.successMessageText = "";
    //  this.radioUpdateNo = true;
    //  this.radioMask = false;
    //  this.radioReset = false;
    //}
    if (radioBtnName === "mask") {
      this.updateBtnText = "Mask User";
      this.isDisabledMobileNo = true;
      this.successMessageText = "";
      this.radioUpdateNo = false;
      this.radioMask = true;
      this.radioReset = false;
    }
    else {
      this.updateBtnText = "Reset Incomplete Assessment";
      this.isDisabledMobileNo = true;
      this.successMessageText = "";
      this.radioUpdateNo = false;
      this.radioMask = false;
      this.radioReset = true;
        // this.isSearchDisable = false;
    }

    if (this.radioMask === true && this.emailIdUserName && this.emailIdUserName.trim() !== "" && !this.invalidEmailFormat) {
      this.isSearchDisable = false;
    }
    if (this.radioReset === true && this.emailIdUserName && this.emailIdUserName.trim() !== "") {
      this.isSearchDisable = false;
    }
  }

  public openConfirmationDialog(userinput) {
    this.confirmationDialogService.confirm('Notice', 'The data, once masked, cannot be accessed or restored by the Admin or user.',
      'OK', 'CANCEL', 'sm', false)
      .then((confirmed) => {
        if (confirmed) {
          this.datacleanupservice.updateMaskNResetAssessment(this.userDet, userinput).subscribe((result) => {
            this.successMessageText = ("User data masking completed.")
            if(this.successMessageText){
              this.showUserDetails = false;
            }
          });
        }
      }
      );
  }

  public autoPopulateOnTabChange() {

    const dataCleanUpData = this.masterDataService.dataCleanUpData;

    if (dataCleanUpData) {
      this.emailIdUserName = dataCleanUpData.emailIdUserName ? dataCleanUpData.emailIdUserName : "";
      this.radioBtnName = dataCleanUpData.radioBtnName ? dataCleanUpData.radioBtnName : "updateMobile";
      this.validateUser = dataCleanUpData.validateUser ? dataCleanUpData.validateUser : false;
      this.userId = dataCleanUpData.userId ? dataCleanUpData.userId : "";
      //this.countryCode = dataCleanUpData.countryCode ? dataCleanUpData.countryCode : "";
      //this.mobileNumber = dataCleanUpData.mobileNumber ? dataCleanUpData.mobileNumber : "";
      //this.countryCodeId = dataCleanUpData.countryCodeId ? dataCleanUpData.countryCodeId : "";
      //this.selectedCountryCodeId = dataCleanUpData.selectedCountryCodeId ? dataCleanUpData.selectedCountryCodeId : 23;
      this.firstName = dataCleanUpData.firstName ? dataCleanUpData.firstName : "";
      this.lastName = dataCleanUpData.lastName ? dataCleanUpData.lastName : "";
      this.countryName = dataCleanUpData.countryName ? dataCleanUpData.countryName : "";
      this.functionName = dataCleanUpData.functionName ? dataCleanUpData.functionName : "";
      this.industry = dataCleanUpData.industry ? dataCleanUpData.industry : "";
      this.position = dataCleanUpData.position ? dataCleanUpData.position : "";
      this.radioUpdateNo = dataCleanUpData.radioUpdateNo ? dataCleanUpData.radioUpdateNo : false;
      this.radioMask = dataCleanUpData.radioMask ? dataCleanUpData.radioMask : false;
      this.radioReset = dataCleanUpData.radioReset ? dataCleanUpData.radioReset : false;
      this.onRadioBtnClick(this.radioBtnName);
      this.onSubmitBtnClick();

    }
  }

  public setValuesToMasterDataObj() {
    const data = {
      //Bug 2938806 fix
      emailIdUserName: this.userInput.userNameOrEmail, //this.emailIdUserName,
      radioBtnName: this.radioBtnName,
      validateUser: this.validateUser,
      userId: this.userId,
      //countryCode: this.countryCode,
      //mobileNumber: this.mobileNumber,
      //countryCodeId: this.countryCodeId,
      //selectedCountryCodeId: this.selectedCountryCodeId,
      firstName: this.firstName,
      lastName: this.lastName,
      countryName: this.countryName,
      functionName: this.functionName,
      industry: this.industry,
      position: this.position,
      radioUpdateNo: this.radioUpdateNo,
      radioMask: this.radioMask,
      radioReset: this.radioReset,
    }
    this.masterDataService.dataCleanUpData = data;
  }
  getUserRole() {
    this.currentRole = Number(this.SessionStorageService.getItem('HighestRoleId'));
    //this.currentRole = this.userRoleService.currentRoleId;
  }
}
